module.exports = __webpack_public_path__ + "img/syjz.54a1c850.jpg";